import { resetParticipantBrightness, resetParticipantContrast, resetParticipantOpacitySetting, resetParticipantSaturation, resetParticipantZoomLevel } from '../../filmstrip/actions.web';
import { setUserVideoBrightnessValue, setUserVideoContrastValue, setUserVideoDimmingValue, setUserVideoSaturationValue, setUserVideoZoomValue, toggleInterpreters, toggleOtherParticipants, toggleScreensharing } from '../uservideo/actions';
import { SET_AUDIO_CUES_ENABLED_STATE, SET_UI_FONTSIZE, SET_UI_ICONSIZE, SET_VISUAL_CUES_ENABLED_STATE } from './actionTypes';
import { getUISettingsTabProps, isAcousticCuesEnabled, isVisualCuesEnabled } from './functions';
/**
 * Submits new values to the state inside the project store.
 *
 * @param {any} newState - The new settings.
 * @returns {Function}
 */
export function submitUISettingsTabProps(newState) {
    return (dispatch, getState) => {
        const currentState = getUISettingsTabProps(getState());
        if (newState.fontSize !== currentState.fontSize) {
            dispatch(setUISettingsFontSize(newState.fontSize));
        }
        if (newState.iconSize !== currentState.iconSize) {
            dispatch(setUISettingsIconSize(newState.iconSize));
        }
        if (newState.visualCues !== currentState.visualCues) {
            dispatch(setVisualCuesEnabledState(newState.visualCues));
        }
        if (newState.brightness !== currentState.brightness) {
            dispatch(setUserVideoBrightnessValue(newState.brightness));
            dispatch(resetParticipantBrightness());
        }
        if (newState.contrast !== currentState.contrast) {
            dispatch(setUserVideoContrastValue(newState.contrast));
            dispatch(resetParticipantContrast());
        }
        if (newState.dimming !== currentState.dimming) {
            dispatch(setUserVideoDimmingValue(newState.dimming));
            dispatch(resetParticipantOpacitySetting());
        }
        if (newState.otherParticipants !== currentState.otherParticipants) {
            dispatch(toggleOtherParticipants());
        }
        if (newState.interpreter !== currentState.interpreter) {
            dispatch(toggleInterpreters());
        }
        if (newState.screensharing !== currentState.screensharing) {
            dispatch(toggleScreensharing());
        }
        if (newState.saturation !== currentState.saturation) {
            dispatch(setUserVideoSaturationValue(newState.saturation));
            dispatch(resetParticipantSaturation());
        }
        if (newState.zoom !== currentState.zoom) {
            dispatch(setUserVideoZoomValue(newState.zoom));
            dispatch(resetParticipantZoomLevel());
        }
    };
}
/**
 * Sets the font size for the UI.
 *
 * @param {number} value - The new value.
 * @returns {Function}
 */
export function setUISettingsFontSize(value) {
    return {
        type: SET_UI_FONTSIZE,
        value
    };
}
/**
 * Sets the icon size for the UI.
 *
 * @param {number} value - The new value.
 * @returns {Function}
 */
export function setUISettingsIconSize(value) {
    return {
        type: SET_UI_ICONSIZE,
        value
    };
}
/**
 * Sets the enabled state of the audio-cues.
 *
 * @param {enabled} enabled - The new value.
 * @returns {Object}
 */
export function setAcousticCuesEnabledState(enabled) {
    return {
        type: SET_AUDIO_CUES_ENABLED_STATE,
        enabled
    };
}
/**
 * Sets the enabled state of the visual-cues.
 *
 * @param {enabled} enabled - The new value.
 * @returns {Object}
 */
export function setVisualCuesEnabledState(enabled) {
    return {
        type: SET_VISUAL_CUES_ENABLED_STATE,
        enabled
    };
}
/**
 * Toggles the active state of the distress button.
 *
 * @returns {Function}
 */
export function toggleAcousticCues() {
    return (dispatch, getState) => {
        if (isAcousticCuesEnabled(getState())) {
            setAcousticCuesEnabledState(false);
        }
        else {
            setAcousticCuesEnabledState(true);
        }
    };
}
/**
 * Toggles the active state of the distress button.
 *
 * @returns {Function}
 */
export function toggleVisualCues() {
    return (dispatch, getState) => {
        if (isVisualCuesEnabled(getState())) {
            setVisualCuesEnabledState(false);
        }
        else {
            setVisualCuesEnabledState(true);
        }
    };
}
